function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './RenderVideo.css';
import React, { memo, useEffect, useRef } from 'react';
import clsx from 'clsx';
import Loader from '../Loader/Loader';
import { ReactComponent as IconPlay } from '../../../resources/icons/IconPlay2.svg';
import { ReactComponent as IconPlaySharedCh } from '../../../resources/icons/IconPlaySharedCh.svg';
import { ReactComponent as IconPauseSharedCh } from '../../../resources/icons/IconPauseSharedCh.svg';
import { ReactComponent as IconPauseItem } from '../../../resources/icons/IconPauseFat.svg';
import Modal from '../Modal/Modal';
const emptyModalVideo = {
  src: '',
  type: '',
  title: '',
  playing: false,
  loading: true,
  visiblePlayButton: true
};
const RenderVideoComponent = _ref => {
  let {
    modalVideoState,
    toggle,
    setModalVideoState,
    callback = () => {},
    checkMouseMoved,
    startOnce,
    setStartOnce,
    isShown,
    isSharedCh
  } = _ref;
  useEffect(() => {
    if (modalVideoState.type === 'media') {
      if (!modalVideoState.loading && !modalVideoState.playing && startOnce) {
        modalPlayButtonHandler();
        setStartOnce(false);
      }
    }
  }, [modalVideoState]);
  const modalVideo = useRef(null);
  const modalPlayButtonHandler = () => {
    if (modalVideo.current) {
      if (modalVideoState.playing) {
        modalVideo.current.pause();
      } else {
        modalVideo.current.play();
      }
      setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
        playing: !modalVideoState.playing
      }));
    }
  };
  const renderVideo = styles => {
    if (!modalVideoState.src || !modalVideoState.type) {
      return null;
    }
    if (modalVideoState.type === 'external') {
      return /*#__PURE__*/React.createElement("div", {
        onClick: () => {
          toggle();
          setModalVideoState(emptyModalVideo);
        },
        className: clsx(styles, 'modal-yt-iframe-container')
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-yt-iframe-ar-container"
      }, /*#__PURE__*/React.createElement("iframe", {
        width: "560",
        height: "315",
        src: modalVideoState.src.includes('?') ? `${modalVideoState.src}&autoplay=1&mute=1` : `${modalVideoState.src}?autoplay=1&mute=1`,
        title: modalVideoState.title,
        allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        referrerPolicy: "strict-origin-when-cross-origin",
        allowFullScreen: true,
        className: "modal-yt-iframe"
      })));
    }
    if (modalVideoState.type === 'media') {
      return /*#__PURE__*/React.createElement("div", {
        onMouseMove: checkMouseMoved,
        className: clsx(styles, {
          'hidden-play-button': !modalVideoState.visiblePlayButton
        })
      }, /*#__PURE__*/React.createElement("video", {
        ref: modalVideo,
        className: clsx('modal-video', {
          'modal-video--load-over': !modalVideoState.loading
        }),
        playsInline: true,
        loop: true,
        onProgress: () => {
          if (modalVideoState.loading) {
            setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
              loading: false
            }));
          }
        },
        muted: false,
        preload: "auto",
        autoPlay: false
      }, /*#__PURE__*/React.createElement("source", {
        src: modalVideoState.src,
        type: "video/mp4"
      }), /*#__PURE__*/React.createElement("track", {
        kind: "captions"
      })), modalVideoState.loading ? /*#__PURE__*/React.createElement(Loader, {
        color: "#000000"
      }) : /*#__PURE__*/React.createElement("button", {
        className: clsx('btn--reset modal-play-button', {
          'modal-play-button--playing': modalVideoState.playing
        }),
        onClick: modalPlayButtonHandler
      }, modalVideoState.playing ? isSharedCh ? /*#__PURE__*/React.createElement(IconPauseSharedCh, null) : /*#__PURE__*/React.createElement(IconPauseItem, null) : isSharedCh ? /*#__PURE__*/React.createElement(IconPlaySharedCh, null) : /*#__PURE__*/React.createElement(IconPlay, null)));
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(Modal, {
    showMobileClose: true,
    fullPageCover: true,
    fullPageVideo: true,
    isShown: isShown,
    isSharedCh: isSharedCh,
    hide: () => {
      if (modalVideo.current && modalVideoState.playing) {
        modalVideo.current.pause();
      }
      toggle();
      setModalVideoState(emptyModalVideo);
    }
  }, renderVideo(isSharedCh ? videplayerStylesSharedCh : videplayerStyles));
};
const videplayerStyles = "v1c6enrx";
export const videplayerStylesSharedCh = "vld1m7a";
export const RenderVideo = /*#__PURE__*/memo(RenderVideoComponent);